import { useState } from 'react';

export const useAppNavigation = (initialTab = 'Home') => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [selectedApp, setSelectedApp] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  const handleAppClick = async (app) => {
    setSelectedApp(app);
    setLoading(true);
    
    // Simulate app loading
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      console.log(`Opening ${app.title}...`);
      // Here you would typically navigate to the app or open it
    } catch (error) {
      console.error('Error opening app:', error);
    } finally {
      setLoading(false);
      setSelectedApp(null);
    }
  };

  return {
    activeTab,
    selectedApp,
    loading,
    handleTabChange,
    handleAppClick
  };
};